import DocumentsFormQuestion from './styled';

export default DocumentsFormQuestion;
